import React from 'react';
import Lottie from 'react-lottie';
import EmptyListAnimation from 'assets/animations/empty_list.json';

interface EmptyResultProps {
  title: string;
  description: any;
}

const EmptyResult: React.FC<EmptyResultProps> = (props: EmptyResultProps) => {
  const { title, description } = props;

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: EmptyListAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <div className="row">
      <div className="col-md-12 text-center mb-5 mt-5">
        <Lottie options={defaultOptions} style={{ width: '300px', margin: '0 auto' }} />
        <h2 className="text-secondary">{title}</h2>
        <h5 className="text-secondary mt-3">{description}</h5>
      </div>
    </div>
  );
};

export default EmptyResult;
